import { axiosInstance } from '../../utils';
import { useMutation } from '@tanstack/react-query';

interface PreSignedUrlResponse {
  uploadId: string;
  preSignedUrls: { url: string; partNumber: number }[];
  format: string;
}

export const generatePreSignedUrl = async (file: File): Promise<PreSignedUrlResponse> => {
  const numberOfParts = Math.ceil(file.size / (50 * 1024 * 1024)); // 100MB per part
  const mimeType = file.type
  const formData = { format: file?.type?.split('/')[0], numberOfParts, mimeType };

  const response = await axiosInstance.post('/api/s3/get-multi-presigned-urls', formData);

  return { uploadId: response.data.uploadId, preSignedUrls: response.data.urls, format: formData.format };
};

export function useGeneratePreSignedUrl() {
  return useMutation(generatePreSignedUrl, {
    onSuccess: (data) => data,
  });
}
